import React from "react";
// import utils
import * as Yup from "yup";
// import component
import PageHeading from "../../components/PageHeading";
import UserForm from "../../components/Forms/UserForm";
import userServices from "../../services/users";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";

const initialValues = {
    name: "",
    username: "",
    password: "",
};
const validationSchema = Yup.object().shape({
    name: Yup.string().required("هذا الحقل مطلوب"),
    username: Yup.string()
        .required("هذا الحقل مطلوب")
        .min(5, "على الاقل 5 محارف"),
    password: Yup.string()
        .required("هذا الحقل مطلوب")
        .min(8, "على الاقل 8 محارف"),
});
const AddUser = ({ title }) => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const onSubmit = (values, { setSubmitting }) => {
        userServices
            .addUser(values)
            .then(res => {
                toast.success("تم الإنشاء بنجاح");
                queryClient.refetchQueries("getUsers");
                setTimeout(() => {
                    navigate("/users", { replace: true });
                }, 1500);
            })
            .catch(err => {
                console.log(err);
                if (err.response.status === 422) {
                    toast.error("اسم المستخدم موجود مسبقا");
                } else {
                    toast.error("فشل إنشاء مستخدم");
                }
                setTimeout(() => {
                    setSubmitting(false);
                }, 1500);
            });
    };

    return (
        <div className="users">
            <PageHeading>{title}</PageHeading>
            <UserForm
                onSubmit={onSubmit}
                initialValues={initialValues}
                validationSchema={validationSchema}
                btnText="إضافة مستخدم"
                gridStyle="sm:grid-cols-3"
            />
        </div>
    );
};

export default AddUser;
